import React from 'react';
import Format from './pages/Format';
import './App.css';

function App() {
  return (
    <div className="App">
      <Format />
    </div>
  );
}

export default App;